/* global YT:true */

const YouTubeAPI = {
    status: {
        LOADING: null,
        READY: null
    },

    defaultPlayerArgs: {
        height: window.innerHeight,
        width: window.innerWidth,
        playerVars: {
            autoplay: 1,
            controls: 0,
            modestbranding: 1,
            showinfo: 0,
            origin: location.href,
            rel: 0,
            iv_load_policy: 3
        }
    },

    injectScriptTag (callback) {
        const tag = document.createElement('script');
        tag.src = '//www.youtube.com/iframe_api';
        document.body.appendChild(tag);
        YouTubeAPI.status.LOADING = true;

        window.onYouTubeIframeAPIReady = function () {
            YouTubeAPI.status.LOADING = false;
            YouTubeAPI.status.READY = true;
            callback();
        };
    },

    init (callback) {
        YouTubeAPI.injectScriptTag(callback);
    },

    createPlayer (targetEl, playerArgs) {
        const combinedArgs = Object.assign({}, YouTubeAPI.defaultPlayerArgs, playerArgs);
        return new YT.Player(targetEl, combinedArgs);
    }
};

export default YouTubeAPI;



// WEBPACK FOOTER //
// ./assets/js/core/YouTubeAPI.js